<template>
  <section class="pb-3 pb-md-0">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center mb-5">
          <h1>Vos bons plans</h1>
        </div>
        <div class="col-12">
          Retrouvez ci-dessous les bons plans proposés spécialement pour vous par nos partenaires.
          Il s'agit uniquement d'entreprises avec lesquelles nous travaillons, dont nous aimons
          les produits ou services, et en qui nous avons confiance !
        </div>
      </div>
      <div class="col-12">
        <v-display
          v-for="perk in filtered"
          :key="perk.id"
          class="my-3"
          v-bind="getPerkAttributes(perk)"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { pick } from 'lodash-es';

import DealsDisplay from '@/components/deals/DealsDisplay.vue';

export default {
  name: 'ClientDeals',
  components: {
    'v-display': DealsDisplay,
  },
  data() {
    return {
      type: null,
    };
  },
  computed: {
    aws: () => 'https://assurup-assets-1.s3.eu-west-3.amazonaws.com/widget',
    perks() {
      return this.$store.getters['perks/get'];
    },
    filtered() {
      if (this.perks) {
        return this.perks.filter(this.perkFilter);
      }
      return [];
    },
  },
  mounted() {
    this.$store.dispatch('perks/setPerks');
  },
  methods: {
    getPerkAttributes(perk) {
      const {
        description, link, name,
        partner,
      } = perk;
      return {
        company: {
          ...pick(partner, ['description', 'name', 'logo']),
        },
        perk: {
          name,
          link,
          description,
        },
      };
    },
    setFilter(type) {
      this.type = type;
    },
    perkFilter(perk) {
      if (this.type === null) {
        return true;
      }
      return perk.tags.includes(this.type);
    },
  },
};
</script>
